<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>
<script>
export default {
  beforeCreate() {
    let self = this;
    let userSession = JSON.parse(localStorage.userSession);

    if (userSession != null) {
      self.$store.commit("setUserSessionData", userSession);
      localStorage.removeItem("userSession");
    }
  },
  mounted() {
    window.addEventListener("unload", this.leaving);
  },
  methods: {
    leaving() {
      let userSession = this.$store.getters.getUserSessionData;

      localStorage.setItem("userSession", JSON.stringify(userSession));

      return null;
    }
  }
}
</script>
<style>
html {
  overflow: auto;
  scrollbar-face-color: #646464;
  scrollbar-base-color: #646464;
  scrollbar-3dlight-color: #646464;
  scrollbar-highlight-color: #646464;
  scrollbar-track-color: #000;
  scrollbar-arrow-color: #000;
  scrollbar-shadow-color: #646464;
}

.scrollbar {
  background: #F5F5F5;
  overflow-y: scroll;
}

.scroll-style::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
}

.scroll-style::-webkit-scrollbar {
  width: 10px;
  background-color: #F5F5F5;
}

.scroll-style::-webkit-scrollbar-thumb {
  background-color: #F90;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, .2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, .2) 50%,
      rgba(255, 255, 255, .2) 75%,
      transparent 75%,
      transparent)
}

.search-location {
  display: block;
  margin: 0 auto;
  margin-bottom: 30px;
  margin-top: 30px;
  width: 100%;
  font-size: 20px;
  font-weight: 400;
  outline: none;
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.87);
}
</style>